module.exports = __webpack_public_path__ + "static/marko-pekic-IpLa37Uj2Dw-unsplash-5d9abbccf4e913ac7981e9694d49b36e.jpg";